/* eslint-disable jsx-a11y/accessible-emoji */

import React from "react";
import { ICreateMedicalFormValues, MedicalCardForm } from "../../forms";
import { useCreateMedicalCardMutation } from "../../graphql";

const CreateMedicalCard: React.FC = () => {
  const [createMedicalCard] = useCreateMedicalCardMutation();

  const onSubmit = async (values: ICreateMedicalFormValues) => {
    const { data, errors } = await createMedicalCard({
      variables: {
        diagnosis: values.diagnosis,
        patientId: 6,
        recipe: values.recipe,
        recommendation: values.recommendation,
        symptoms: values.symptoms,
        privateNote: values.privateNote,
        medicalConcernCategoryId: parseInt(values.medicalConcernCategoryId),
      },
    });
  };

  return (
    <MedicalCardForm
      onSubmit={onSubmit}
      initialValues={{
        diagnosis: ".....",
      }}
    />
  );
};

export default CreateMedicalCard;
